import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs/Sortable.min";

export default class extends Controller {
  connect() {
    const { url, ...params } = JSON.parse(this.data.get("params"));

    this.sortable = new Sortable(this.element, {
      animation: 150,
      onSort: () => {
        const ids = $("[data-sortable-item-id]", this.element)
          .map((_, element) => element.dataset.sortableItemId)
          .get();

        $.ajax(url, {
          method: "PUT",
          contentType: "application/json",
          dataType: 'json',
          data: JSON.stringify({ ids }),
        });
      },
      ...params,
    });
  }

  disconnect() {
    this.sortable.destroy();
  }
}
